import { useEffect, useMemo } from 'react';

import { PageHero, Shell } from '../components';
import { webConfig } from '../config';
import { readInviteToken } from '../navigation';

export function InvitePage() {
  const token = useMemo(() => readInviteToken(window.location), []);
  const deepLink = token
    ? `${webConfig.appScheme}://invite?token=${encodeURIComponent(token)}`
    : `${webConfig.appScheme}://invite`;

  useEffect(() => {
    if (token && window.location.search) window.history.replaceState({}, '', '/invite');
  }, [token]);

  return (
    <Shell>
      <main className="narrow-page">
        <PageHero
          eyebrow="FAMILY INVITATION"
          title={
            <>
              <span style={{ display: 'inline-block' }}>家族のこばこ</span>で
              <br />
              思い出を一緒に。
            </>
          }
        >
          <p>子どもの成長の記録を、家族で大切に残していきましょう。</p>
        </PageHero>
        <section className="invite-card">
          <div className="invite-stamp" aria-hidden="true">
            <img src="/app-icon.png" alt="" width="40" height="40" />
            <b>招待状</b>
          </div>
          {token ? (
            <>
              <div>
                <p className="eyebrow">YOUR INVITATION</p>
                <h2>アプリで招待を受け取る</h2>
                <p>
                  AppleまたはGoogleでログインしたあと、この招待を一度だけ使用して家族に参加します。
                </p>
              </div>
              <a className="button primary wide" href={deepLink}>
                うちのこばこを開く <span aria-hidden="true">→</span>
              </a>
              <p className="security-note">
                心当たりのある家族からの招待だけを受け取ってください。参加できない場合は、新しい招待コードを発行してもらえます。
              </p>
            </>
          ) : (
            <>
              <h2>8文字の招待コードで参加</h2>
              <p>
                家族から受け取ったコードを、アプリの最初の画面にある「招待コードで参加」、または「設定」→「招待コードで参加する」に入力してください。
              </p>
              <a className="button primary wide" href={deepLink}>
                アプリでコードを入力する <span aria-hidden="true">→</span>
              </a>
              <p className="security-note">
                コードは7日間有効で、1人だけ参加できます。期限切れ・使用済みの場合は、招待した家族に新しいコードを発行してもらってください。
              </p>
            </>
          )}
        </section>
        {webConfig.iosStoreUrl && webConfig.androidStoreUrl ? (
          <section className="store-links">
            <p>アプリをまだお持ちでない方</p>
            <div>
              <a href={webConfig.iosStoreUrl}>App Store</a>
              <a href={webConfig.androidStoreUrl}>Google Play</a>
            </div>
          </section>
        ) : null}
      </main>
    </Shell>
  );
}
